import { render, staticRenderFns } from "./StpDetail.vue?vue&type=template&id=2dd3eebe&"
import script from "./StpDetail.vue?vue&type=script&lang=ts&"
export * from "./StpDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports